export const PurchaseOrderType = {
    OrderNumber: 1,
    SupplierReturnNumber: 2,
  };